export const STATE = {
  PLAYING: 'PLAYING',
  OVER: 'OVER',
  SCORE: 'SCORE',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};

export const CATEGORY = {
  TSUME: 'tsume',
  GAME: 'game',
};

export default {
  STATE,
  CATEGORY,
};
